import { defineMessages } from 'react-intl';

const _default_1: {
	homeBreadcrumb: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	hubLoadingSpinnerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	homeBreadcrumb: {
		id: 'hub.hub.homeBreadcrumb',
		defaultMessage: 'Home',
		description: 'Breadcrumb label linking back to the Help Hub home page.',
	},
	hubLoadingSpinnerLabel: {
		id: 'company-hub.hub.loading-spinner-label',
		defaultMessage: 'Loading hub',
		description:
			'Accessible label for the loading spinner shown while the company hub page is being loaded.',
	},
});
export default _default_1;
